module.exports = __webpack_public_path__ + "media/images/ipad-9e778e356d7672a081b433d9ca9ef6fa.jpg";